module.exports = __webpack_public_path__ + "img/Dummy.cd571e6a.png";